import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useParams, useSearchParams } from "react-router-dom";
import { useSakusasPositionGet } from "hooks/sakusas/position/useSakusasPositionGet";
import PositionEdit from "./PositionEdit";
import PositionRead from "./PositionRead";

const PositionComponent = () => {
  const { positionId } = useParams();
  const [searchParams] = useSearchParams();
  const [mode, setMode] = useState<string>("");
  const position = useSakusasPositionGet(positionId as string);
  useEffect(() => {
    const paramsMode = searchParams.get("mode") ?? "";
    if (paramsMode !== mode) {
      setMode(paramsMode);
    }
  }, [searchParams]);

  if (!position) {
    return null;
  }

  return (
    <>
      {mode !== "edit" && <PositionRead position={position} />}
      {mode === "edit" && <PositionEdit position={position} />}
    </>
  );
};

export default PositionComponent;
